import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { removeLocalStorageData } from "../../plugins/logoutFunction";
import {
  apiGetGiftPoint,
  apiGetGiftPointRecord,
  apiGetUserInfo,
  apiGetUserOrderHistory,
  apiLogout,
  apiUpdateUserInfo,
} from "./service";

export const useGetUserInfo = (options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.USER_INFO],
    queryFn: () => apiGetUserInfo().then((res: any) => res.data.data),
    ...options,
  });
};

export const useGetGiftPoint = (options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.GIFT_POINT],
    queryFn: () => apiGetGiftPoint().then((res: any) => res.data.data),
    ...options,
  });
};

export const useGetGiftPointRecord = (params: any, options: any) => {
  return useQuery<any>({
    // queryKey: [queryKey.GIFT_POINT],
    queryFn: () =>
      apiGetGiftPointRecord(params).then((res: any) => res.data.data),
    ...options,
  });
};

export const useUpdateUserInfo = () => {
  const cache = useQueryClient();
  return useMutation({
    mutationFn: ({ params }: { params: any }) => apiUpdateUserInfo(params),
    onSuccess: () => {
      cache.invalidateQueries({ queryKey: [queryKey.USER_INFO] });
    },
    onError: (error: any) => {
      console.debug(JSON.stringify("ERR", error));
    },
  });
};

// export const useGetOrderHistory = (options: any) => {
//   return useQuery<any>({
//     queryKey: [queryKey.ORDER_HISTORY],
//     queryFn: () => apiGetUserOrderHistory().then((res: any) => res.data.data),
//     ...options,
//   });
// };

export const useGetOrderHistory = ({
  params,
  options,
}: {
  params: any;
  options: any;
}) => {
  Object.keys(params).forEach((key) => {
    if (
      params[key] === null ||
      params[key] === undefined ||
      params[key] === ""
    ) {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery<any>({
    queryKey: [queryKey.ORDER_HISTORY, ..._arrParams],
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      apiGetUserOrderHistory({
        ...params,
        page: pageParam,
        page_size: 30,
      }).then((res: any) => {
        return res.data.data;
      }),
    ...options,
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useLogout = () => {
  return useMutation({
    mutationFn: () => apiLogout(),
    onSuccess: () => {
      removeLocalStorageData();
      setTimeout(() => {
        window.location.pathname = "/";
      }, 1000);
    },
  });
};
